import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, Output, EventEmitter} from '@angular/core';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../../services/modal/modal.service';
import {UserService} from '../../../services/user.service';
import {UserBilling, UserMonthlyUsage} from '../../../../models/Billing/billing-details';
import {AppSettings} from '../../../utils/app-settings';

@Component({
  selector: 'user-billing-details',
  templateUrl: './user-billing.component.html',
  styleUrls: ['./user-billing.component.scss']
})
export class UserBillingComponent implements OnInit, OnChanges {
  @ViewChild('UserBillingNotification') userBillingNotification: AchooPopupComponent;
  @Input() userBilling: UserBilling;
  @Input() userMonthlyUsage: UserMonthlyUsage;
  @Input() shouldReloadPage: boolean;
  @Output() requestReloadBilling = new EventEmitter();

  notificationTitle: string;
  notificationContent: string;
  userBillingDetails: UserBilling;
  private notificationRef;

  ngOnChanges(changes: SimpleChanges) {
    if (this.userBilling && changes.userBilling && changes.userBilling.currentValue) {
      this.userBillingDetails = changes.userBilling.currentValue;
    }
  }
  constructor(private translate: TranslateService,
              private modalService: ModalService,
              private userService: UserService) {
  }

  ngOnInit() {
    if (this.userBilling) {
      this.userBillingDetails = this.userBilling;
    }
  }

  showError(errorMsg) {
    this.notificationTitle = this.translate.instant('notification.error');
    this.notificationContent = errorMsg;
    this.notificationRef = this.modalService.open(this.userBillingNotification, null, true);
  }

  afterUpdateSubscription(evt) {
    if (evt.isError) {
      this.showError(evt.message);
    }
  }

  reloadBilling(): void {
    this.requestReloadBilling.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/user-billing.component.ts